import React, { useContext } from "react";
import { Field, useFormikContext } from "formik";

import {
  DialogContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import TabPanel from "../TabPanel";
import { AuthContext } from "../../context/Auth/AuthContext";

/**
 * Tab "Chatbot" — tempos de ticket, mensagens de inatividade e fluxo de inatividade.
 * Compartilhada entre WhatsAppModal (nativo) e PluginConnectionModal.
 * Lê dados do Formik via useFormikContext; estado/handler do fluxo de inatividade e
 * o dataset `webhooks` (flows) vêm por props (não estão no Formik).
 */
const ChatbotTab = ({
  tab,
  classes,
  webhooks,
  flowIdInactiveTime,
  handleChangeFlowIdInactiveTime,
}) => {
  const { values, touched, errors } = useFormikContext();
  const { user } = useContext(AuthContext);

  return (
    <TabPanel className={classes.container} value={tab} name="chatbot">
      <DialogContent dividers>
        <Grid spacing={2} container>
          {/* TEMPO PARA CRIAR NOVO TICKET */}
          <Grid xs={6} md={3} item>
            <Field
              as={TextField}
              label={i18n.t("whatsappModal.form.timeCreateNewTicket")}
              fullWidth
              name="timeCreateNewTicket"
              variant="outlined"
              margin="dense"
              error={
                touched.timeCreateNewTicket &&
                Boolean(errors.timeCreateNewTicket)
              }
              helperText={
                touched.timeCreateNewTicket && errors.timeCreateNewTicket
              }
            />
          </Grid>

          {/* QUANTIDADE MÁXIMA DE VEZES QUE O CHATBOT VAI SER ENVIADO */}
          <Grid xs={6} md={3} item>
            <Field
              as={TextField}
              label={i18n.t("whatsappModal.form.maxUseBotQueues")}
              fullWidth
              name="maxUseBotQueues"
              variant="outlined"
              margin="dense"
              error={
                touched.maxUseBotQueues && Boolean(errors.maxUseBotQueues)
              }
              helperText={touched.maxUseBotQueues && errors.maxUseBotQueues}
            />
          </Grid>
          {/* TEMPO PARA ENVIO DO CHATBOT */}
          <Grid xs={6} md={3} item>
            <Field
              as={TextField}
              label={i18n.t("whatsappModal.form.timeUseBotQueues")}
              fullWidth
              name="timeUseBotQueues"
              variant="outlined"
              margin="dense"
              error={
                touched.timeUseBotQueues && Boolean(errors.timeUseBotQueues)
              }
              helperText={touched.timeUseBotQueues && errors.timeUseBotQueues}
            />
          </Grid>
          {/* TEMPO PARA RETORNAR A FILA */}
          <Grid xs={6} md={3} item>
            <Field
              as={TextField}
              label={i18n.t("whatsappModal.form.timeToReturnQueue")}
              fullWidth
              name="timeToReturnQueue"
              variant="outlined"
              margin="dense"
              error={
                touched.timeToReturnQueue && Boolean(errors.timeToReturnQueue)
              }
              helperText={
                touched.timeToReturnQueue && errors.timeToReturnQueue
              }
            />
          </Grid>
        </Grid>
        <Grid spacing={2} container>
          {/* ENCERRAR CHATS ABERTOS APÓS X HORAS */}
          <Grid xs={6} md={6} item>
            <Field
              as={TextField}
              label={i18n.t("whatsappModal.form.expiresTicket")}
              fullWidth
              name="expiresTicket"
              required={values.timeInactiveMessage > 0}
              variant="outlined"
              margin="dense"
              error={touched.expiresTicket && Boolean(errors.expiresTicket)}
              helperText={touched.expiresTicket && errors.expiresTicket}
            />
          </Grid>
          {/* TEMPO PARA ENVIO DO CHATBOT */}
          <Grid xs={6} md={6} item>
            <FormControl
              variant="outlined"
              margin="dense"
              fullWidth
            // className={classes.formControl}
            >
              <InputLabel id="whenExpiresTicket-selection-label">
                {i18n.t("whatsappModal.form.whenExpiresTicket")}
              </InputLabel>
              <Field
                as={Select}
                label={i18n.t("whatsappModal.form.whenExpiresTicket")}
                placeholder={i18n.t("whatsappModal.form.whenExpiresTicket")}
                labelId="whenExpiresTicket-selection-label"
                id="whenExpiresTicket"
                name="whenExpiresTicket"
              >
                <MenuItem value={"0"}>
                  {i18n.t("whatsappModal.form.closeLastMessageOptions1")}
                </MenuItem>
                <MenuItem value={"1"}>
                  {i18n.t("whatsappModal.form.closeLastMessageOptions2")}
                </MenuItem>
              </Field>
            </FormControl>
          </Grid>
        </Grid>
        {/* MENSAGEM POR INATIVIDADE*/}
        <div>
          <Field
            as={TextField}
            label={i18n.t("whatsappModal.form.expiresInactiveMessage")}
            multiline
            rows={4}
            fullWidth
            name="expiresInactiveMessage"
            error={
              touched.expiresInactiveMessage &&
              Boolean(errors.expiresInactiveMessage)
            }
            helperText={
              touched.expiresInactiveMessage && errors.expiresInactiveMessage
            }
            variant="outlined"
            margin="dense"
          />
        </div>

        {/* TEMPO PARA ENVIO DE MENSAGEM POR INATIVIDADE */}
        <Field
          as={TextField}
          label={i18n.t("whatsappModal.form.timeInactiveMessage")}
          fullWidth
          name="timeInactiveMessage"
          variant="outlined"
          margin="dense"
          error={
            touched.timeInactiveMessage && Boolean(errors.timeInactiveMessage)
          }
          helperText={
            touched.timeInactiveMessage && errors.timeInactiveMessage
          }
        />
        {/* MENSAGEM POR INATIVIDADE*/}
        <div>
          <Field
            as={TextField}
            label={i18n.t("whatsappModal.form.inactiveMessage")}
            multiline
            rows={4}
            fullWidth
            name="inactiveMessage"
            error={
              touched.inactiveMessage && Boolean(errors.inactiveMessage)
            }
            helperText={touched.inactiveMessage && errors.inactiveMessage}
            variant="outlined"
            margin="dense"
          />
        </div>

        <Grid spacing={2} container>
          {user.showFlow === "enabled" && (
            <>
              {/* TEMPO PARA ENVIO DE MENSAGEM POR INATIVIDADE */}
              <Grid xs={6} md={4} item>
                <Field
                  as={TextField}
                  label={i18n.t("whatsappModal.form.flowInactiveTime")}
                  fullWidth
                  name="flowInactiveTime"
                  variant="outlined"
                  margin="dense"
                  error={
                    touched.flowIdInactiveTime &&
                    Boolean(errors.flowIdInactiveTime)
                  }
                  helperText={
                    touched.flowIdInactiveTime && errors.flowIdInactiveTime
                  }
                />
              </Grid>
            </>
          )}
          {/* QUANTIDADE MÁXIMA DE VEZES QUE O FLOW DE INATIVIDADE VAI SER ENVIADO */}
          <Grid xs={6} md={4} item>
            <Field
              as={TextField}
              label={i18n.t("whatsappModal.form.maxUseInactiveTime")}
              fullWidth
              name="maxUseInactiveTime"
              variant="outlined"
              margin="dense"
              error={
                touched.maxUseInactiveTime &&
                Boolean(errors.maxUseInactiveTime)
              }
              helperText={
                touched.maxUseInactiveTime && errors.maxUseInactiveTime
              }
            />
          </Grid>

          {user.showFlow === "enabled" && (
            <Grid xs={6} md={4} item>
              {/* FLUXO DE INATIVIDADE */}
              <div>
                <FormControl
                  variant="outlined"
                  margin="dense"
                  className={classes.FormControl}
                  fullWidth
                >
                  <Select
                    name="flowIdInactiveTime"
                    value={flowIdInactiveTime || ""}
                    onChange={handleChangeFlowIdInactiveTime}
                    id="flowIdInactiveTime"
                    variant="outlined"
                    margin="dense"
                    labelId="flowIdInactiveTime-selection-label"
                  >
                    <MenuItem value={null}>{"Desabilitado"}</MenuItem>
                    {webhooks.map((webhook) => (
                      <MenuItem key={webhook.id} value={webhook.id}>
                        {webhook.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </Grid>
          )}
        </Grid>
      </DialogContent>
    </TabPanel>
  );
};

export default ChatbotTab;
